module.exports = __webpack_public_path__ + "static/media/logo-app-store.c5f60b5b.svg";